import { useMutation } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { MESSAGING_API_BASE } from '../config';

export type RemoveWhatsappMemberDTO = {
  channelId: number;
  memberId: number;
};

const removeWhatsappMember = async (
  data: RemoveWhatsappMemberDTO
): Promise<{ success: boolean }> => {
  const { channelId, memberId } = data;

  return axios.delete(
    `${MESSAGING_API_BASE}/channels/${channelId}/whatsapp/members/${memberId}`
  );
};

export const useRemoveWhatsappMember = () => {
  return useMutation({
    mutationFn: (data: RemoveWhatsappMemberDTO) => removeWhatsappMember(data),
  });
};
